<template>
  <div class="vet-upload-info" v-if="vetUploadInfo">
    <div class="vet-upload-title">编号: {{ vetUploadInfo.guid }}</div>
    <div v-if="uploadTypeLabel">
      上传类型:
      <span :class="uploadTypeClassName">{{ uploadTypeLabel }}</span>
    </div>
    <div v-if="statusLabel">
      当前状态:
      <span :class="statusClassName">{{ statusLabel }}</span>
    </div>
    <div v-if="vetUploadInfo.createTime > 0">
      创建时间:
      <span>
        {{ new Date(vetUploadInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
      </span>
    </div>
    <div v-if="vetUploadInfo.uploadTime > 0">
      上传时间:
      <span>
        {{ new Date(vetUploadInfo.uploadTime).format("YYYY-MM-dd hh:mm:ss") }}
      </span>
    </div>
    <div v-if="vetUploadInfo.optStatus == 0">
      计划时间:
      <span>
        {{
          new Date(vetUploadInfo.plannedUploadTime).format(
            "YYYY-MM-dd hh:mm:ss"
          )
        }}
      </span>
    </div>
    <div v-if="vetUploadInfo.handledBy">
      操作人员:
      <span>
        {{ vetUploadInfo.handledBy }}
      </span>
    </div>
    <div v-if="vetUploadInfo.uploadZsmCount">
      追溯码数:
      <span> {{ vetUploadInfo.uploadZsmCount }}个码 </span>
    </div>
    <div v-if="vetUploadInfo.uploadErrorMsg">
      失败原因:
      <span style="color: #ff0000">
        {{ vetUploadInfo.uploadErrorMsg }}
      </span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.vet-upload-info {
  line-height: 26px;
  font-size: 14px;
}

.vet-upload-title {
  font-size: 16px;
  font-weight: bolder;
  line-height: 35px;
}

.vet-upload-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.vet-upload-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #5c5c5c;
  color: #5c5c5c;

  &.outbound {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }

  &.inbound {
    background-color: #3399ff;
    border: 1px solid #3399ff;
    color: #ffffff;
  }

  &.none {
    background-color: #919191;
    border: 1px solid #919191;
    color: #ffffff;
  }

  &.finish {
    background-color: #67c23a;
    border: 1px solid #67c23a;
    color: #ffffff;
  }

  &.querying {
    background-color: #3399ff;
    border: 1px solid #3399ff;
    color: #ffffff;
  }

  &.error {
    background-color: #f56c6c;
    border: 1px solid #f56c6c;
    color: #ffffff;
  }
}
</style>

<script>
export default {
  props: {
    vetUploadInfo: {
      type: Object
    }
  },
  methods: {
    getGoodsCount(skuGuid, uploadType) {
      let count = 0;
      if (this.vetUploadInfo) {
        if (this.vetUploadInfo.uploadType == uploadType) {
          (this.vetUploadInfo.itemList || []).forEach(goods => {
            if (goods.skuGuid == skuGuid) {
              count += goods.goodsCount;
            }
          })
        }
      }
      return count;
    },
  },
  computed: {
    orderGoodsList() {
      let goodsList = [];
      let skuGuids = [];
      if (this.vetUploadInfo) {
        (this.vetUploadInfo.itemList || []).forEach(goods => {
          if (skuGuids.indexOf(goods.skuGuid) < 0) {
            goodsList.push(goods);
            skuGuids.push(goods.skuGuid);
          }
        });
      }
      return goodsList;
    },
    statusClassName() {
      if (!this.vetUploadInfo) {
        return '';
      }
      if (this.vetUploadInfo.optStatus == 0) {
        return 'vet-upload-status none';
      } else if (this.vetUploadInfo.optStatus == 1) {
        return 'vet-upload-status finish';
      } else if (this.vetUploadInfo.optStatus == 2) {
        return 'vet-upload-status querying';
      } else if (this.vetUploadInfo.optStatus == 3) {
        return 'vet-upload-status error';
      }
      return '';
    },
    statusLabel() {
      if (!this.vetUploadInfo) {
        return '';
      }
      if (this.vetUploadInfo.optStatus == 0) {
        return '待上传';
      } else if (this.vetUploadInfo.optStatus == 1) {
        return '已上传';
      } else if (this.vetUploadInfo.optStatus == 2) {
        return '待查询';
      } else if (this.vetUploadInfo.optStatus == 3) {
        return '失败';
      }
      return '-';
    },
    uploadTypeClassName() {
      if (!this.vetUploadInfo) {
        return '';
      }
      if (this.vetUploadInfo.uploadType === 'inbound') {
        return 'vet-upload-status inbound';
      } else if (this.vetUploadInfo.uploadType === 'outbound') {
        return 'vet-upload-status outbound';
      } else if (this.vetUploadInfo.uploadType === 'return') {
        return 'vet-upload-status return';
      }
      return '';
    },
    uploadTypeLabel() {
      if (!this.vetUploadInfo) {
        return '';
      }
      if (this.vetUploadInfo.uploadType === 'inbound') {
        return '入库';
      } else if (this.vetUploadInfo.uploadType === 'outbound') {
        return '出库';
      } else if (this.vetUploadInfo.uploadType === 'return') {
        return '退库';
      }
      return this.vetUploadInfo.uploadType;
    }
  }
}
</script>
